import biweeklyImage from "@/assets/biweekly.png";
import weeklyImage from "@/assets/weekly.png";
import { Button } from "@/components/ui/button";
import { cn } from "@/services/hooks/utils";
import { updateRegistryDataMutation } from "@/services/queries";
import { useEffect } from "react";
import { useState } from "react";

type FrecuencyProps = {
    onGoBack: () => void;
    initialFrecuency: "Semanal" | "Quincenal";
};

const Frecuency = ({ onGoBack, initialFrecuency }: FrecuencyProps) => {
    const [selectedFrecuency, setSelectedFrecuency] =
        useState(initialFrecuency);
    const mutation = updateRegistryDataMutation();

    // Redirect to summary if the mutation is successful
    useEffect(() => {
        if (mutation.isSuccess) {
            onGoBack();
        }
    }, [mutation.isSuccess, onGoBack]);

    const handleChangeFrecuency = () => {
        mutation.mutate({
            form_shipping_frecuency: selectedFrecuency,
        });
    };

    const handleKeyDown = (
        event: React.KeyboardEvent,
        frecuency: "Semanal" | "Quincenal",
    ) => {
        if (event.key === "Enter" || event.key === " ") {
            setSelectedFrecuency(frecuency);
            event.preventDefault();
        }
    };

    return (
        <div>
            <div className="grid grid-cols-2 gap-4 mb-8">
                <button
                    type="button"
                    onClick={() => setSelectedFrecuency("Semanal")}
                    onKeyDown={(e) => handleKeyDown(e, "Semanal")}
                    className={cn(
                        "p-2 rounded-md border border-border text-center flex flex-col items-center",
                        selectedFrecuency === "Semanal" &&
                            "border-primary border-2 bg-primary/10 font-semibold",
                    )}
                >
                    <div className="w-24 py-2">
                        <img src={weeklyImage} alt="Icono de plan semanal" />
                    </div>
                    <span>Semanal</span>
                </button>
                <button
                    type="button"
                    onClick={() => setSelectedFrecuency("Quincenal")}
                    onKeyDown={(e) => handleKeyDown(e, "Quincenal")}
                    className={cn(
                        "p-2 rounded-md border border-border text-center flex flex-col items-center",
                        selectedFrecuency === "Quincenal" &&
                            "border-primary border-2 bg-primary/10 font-semibold",
                    )}
                >
                    <div className="w-24 py-2">
                        <img
                            src={biweeklyImage}
                            alt="Icono de plan quincenal"
                        />
                    </div>
                    <span>Quincenal</span>
                </button>
            </div>
            <div className="grid grid-cols-2 gap-4 pt-2">
                <Button
                    variant="outline"
                    disabled={mutation.isPending}
                    onClick={() => onGoBack()}
                >
                    Volver
                </Button>
                <Button
                    disabled={mutation.isPending}
                    onClick={handleChangeFrecuency}
                >
                    {mutation.isPending ? "Cambiando..." : "Seleccionar"}
                </Button>
            </div>
        </div>
    );
};

export default Frecuency;
